/* Copyright (c) 2018 Backpack Health LLC */
import * as React from 'react';
import * as _ from 'lodash';

import { eSurveyQuestionCategoryName, iSurveyResponse } from '../../../../apiServices/SurveyService';
import Card, { CardSection } from '../../../components/card/Card';
import DatePickerToggle from '../../../components/DatePickerToggle';
import { TimeFromNow, FixedDate } from '../../../localization/LocalizedDate';
import BackpackSource from './components/BackpackSource';

export const NestedFuzzyDateQuestion = (props) => {
  const { onUpdate, question, response, profileId } = props;
  const fuzzyDate = response[eSurveyQuestionCategoryName.fuzzyDate] || {};
  const date = fuzzyDate.date || '';
  const precision = fuzzyDate.precision || '';
  const fuzzyDateQuestionSource = _.get(question, `${eSurveyQuestionCategoryName.fuzzyDate}.source`, null);

  return (
    <>
      <DatePickerToggle
        label="pastDates.date.field.label"
        date={date}
        precision={precision}
        name="fuzzy_date"
        onChange={(dateData) => {
          onUpdate({
            category: eSurveyQuestionCategoryName.fuzzyDate,
            [eSurveyQuestionCategoryName.fuzzyDate]: dateData,
          });
        }}
        isFuzzy
        hasToday={true}
        allowNull={false}
        initialFocus={false}
        onFocus={() => {}}
        onCancel={() => {}}
        warningHint=""
        earliestDateWarningLimit=""
      >
        <TimeFromNow
          dateData={{ date, precision }}
        />
      </DatePickerToggle>

      {
        fuzzyDateQuestionSource && (
          <BackpackSource
            source={fuzzyDateQuestionSource}
            value={<FixedDate {...fuzzyDateQuestionSource.value} dateKind="medium" />}
            profileId={profileId}
          />
        )
      }
    </>
  );
};

const FuzzyDateQuestion = (props) => (
  <Card>
    <CardSection hasBorder={false}>
      <NestedFuzzyDateQuestion {...props} />
    </CardSection>
  </Card>
);

interface FuzzyDateAnswerProps {
  className: string;
  style: object;
  answer: iSurveyResponse;
}
export const FuzzyDateAnswer = (props: FuzzyDateAnswerProps) => {
  const { answer, className, style } = props;

  return (
    <div className={className} style={style}>
      <FixedDate {...answer[answer.category]} dateKind="medium" />
    </div>
  );
};

export default FuzzyDateQuestion;
